import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Input, Button } from 'reactstrap';

import './InputWithButton.scss';

export default class InputWithButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showItem': false,
    };
    this.ref = createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutSide);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutSide = event => {
    if (this.ref.current && !this.ref.current.contains(event.target)) {
      return this.setState({ 'showItem': false });
    }
    return;
  }

  handleFocus = showItem => this.setState({ showItem });

  render() {
    const { showItem } = this.state;
    const {
      template,
      icon,
      id,
      placeholder,
      value,
      onChange,
      onKeyPress,
      maxLength,
      onClick,
      btnText,
      showAutoFill,
      dataAutoFill,
    } = this.props;

    return (
      <div className={`InputWithButton${template ? ` template-${template}` : ''}`}>
        <div className="group-input">
          <span className={`icon${icon ? ` ${icon}` : ''}`}/>
          <Input
            id={id}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onKeyPress={onKeyPress}
            maxLength={maxLength}
            onFocus={() => this.handleFocus(true)}
          />
          <Button id={`btn-${id}`} onClick={onClick}>{btnText}</Button>
        </div>
        {
          showAutoFill && showItem && dataAutoFill && dataAutoFill.length > 0 ?
            <div className="group-auto-fill" ref={this.ref}>
              <div className="box-autofill">
                {dataAutoFill}
              </div>
            </div>
            : null
        }
      </div>
    );
  }
}

InputWithButton.propTypes = {
  'icon': PropTypes.string.isRequired,
  'btnText': PropTypes.string.isRequired,
  'placeholder': PropTypes.string,
  'value': PropTypes.string,
  'onChange': PropTypes.func,
  'onClick': PropTypes.func,
  'onKeyPress': PropTypes.func,
  'maxLength': PropTypes.string,
  'id': PropTypes.string,
  'template': PropTypes.string,
  'showAutoFill': PropTypes.bool,
  'dataAutoFill': PropTypes.any,
};
